export default __webpack_public_path__ + "static/media/Page9.af842d7b.txt";